<template>
  <div>
    <Three @setProgress="progress" :activePage="activepage">
      <div v-if="isLoading" class="contain" :class="{'contain-form' : this.activepage != 'main'}">
        <div v-if="isLoading" class="bar">
          <div ref="bar" class="inner"></div>
        </div>
        <v-scroll-y-transition leave-absolute>
          <div v-if="!isLoading && activepage == 'main'" class="actions">
            <!-- <div class="counterbox-title">
              <img style="width:100%;" src="../../img/text2.png" alt />
            </div>-->
            <!-- <div class="btns">
              <div @click="getOne" class="getonebtn">Get One</div>
              <div class="getonebtn">Sign Up</div>
            </div>-->
          </div>
        </v-scroll-y-transition>
        <v-expand-transition leave-absolute>
          <div v-if="!isLoading && activepage == 'getone'" class="actions">
            <div class="counterbox-title">Get One</div>
            <form class="form">
              <div class="input-row">
                <StandardInput
                  width="100%"
                  type="text"
                  label="First Name"
                  placeholder="First"
                  name="first_name"
                ></StandardInput>
                <StandardInput
                  width="100%"
                  type="text"
                  label="Last Name"
                  placeholder="Last"
                  name="last_name"
                ></StandardInput>
              </div>
              <div class="dlabel">Address</div>
              <div class="input-row">
                <StandardInput
                  width="100%"
                  type="text"
                  name="street1"
                  label="Street"
                  placeholder="Street"
                ></StandardInput>
                <StandardInput
                  width="150px"
                  type="text"
                  name="street2"
                  label="Street 2"
                  placeholder="Street 2"
                ></StandardInput>
              </div>
              <div class="input-row">
                <StandardInput width="100%" type="text" name="city" label="City" placeholder="City"></StandardInput>
                <StandardInput
                  width="250px"
                  type="text"
                  name="state"
                  label="State"
                  placeholder="State"
                ></StandardInput>
                <StandardInput width="150px" type="text" name="zip" label="Zip" placeholder="Zip"></StandardInput>
              </div>
            </form>
            <div class="btns">
              <div @click="activepage = 'main'" class="getonebtn">Back</div>
              <div @click="getOne" class="getonebtn">Buy Now</div>
            </div>
          </div>
        </v-expand-transition>
      </div>
    </Three>

    <!-- <div :class="$style.container">
   
    <div class="animated zoomIn" :class="$style.loginForm">
    <div :class="$style.innerForm">
        <div class="animated fadeInDown" :class="$style.loginLogo">
                <img src="../../img/logo.png" alt=""><br>
            
        </div>
        <div>
            <form @submit.prevent="login">
                <div style="padding:15px;">
                <v-text-field class="animated fadeInLeft" v-model="email" dark background-color="transparent" :color="$vuetify.theme.lightGreen" label="Email"></v-text-field>
                <v-text-field class="animated fadeInRight" v-model="password" dark background-color="transparent" :color="$vuetify.theme.lightGreen" type="password" label="Password"></v-text-field>
            </div>
                <v-btn :loading="isLoading" type="submit" :class="$style.loginBtn" dark :color="$vuetify.theme.lightGreen" depressed><span style="text-transform: none">Login</span></v-btn>
            </form>
            <transition enter-active-class="shake" leave-active-class="fadeOut">
                <div :class="$style.errorMessage" class="animated" v-if="hasError">{{errorMessage}}</div>
            </transition>
        </div>
    </div>
        <div style="width:100%; color:#33383b; text-align:center; font-size:10pt;padding:15px; background:#161a1d">
                Forgot Password? <div @click="$router.push('/forgot')" :class="$style.link">Click here</div>
        </div>
    </div>
    
    </div>-->
  </div>
</template>
<script>
import auth from "../../auth";
import Three from "./3d";
import StandardInput from "../form_elements/standard_input";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      hasError: false,
      isLoading: true,
      activepage: "main"
    };
  },
  mounted() {},
  components: {
    Three,
    StandardInput
  },
  computed: {},
  methods: {
    progress(prog) {
      console.log(this.$refs);
      this.$refs.bar.style.transform = `scaleX(${prog.loaded / prog.total})`;
      if ((prog.loaded / prog.total) * 100 >= 100) {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    },
    getOne() {
      this.activepage = "getone";
    },
    login() {
      this.isLoading = true;
      this.hasError = false;
      auth.login({ email: this.email, password: this.password }).then(
        res => {
          this.$router.push("/dashboard");
        },
        err => {
          this.isLoading = false;
          this.hasError = true;
          console.log(err);
          this.errorMessage = err.response.data.error;
        }
      );
    }
  }
};
</script>
<style>
.bar {
  height: 5px;
  border: solid 1px #fff;
  width: 100%;
  position: relative;
}
.inner {
  background: #fff;
  transform: scaleX(0);
  transform-origin: 0%;
  position: absolute;
  left: 0;
  height: 100%;
  width: 100%;
  transition: all 0.3s ease;
  top: 0;
}
.contain {
  position: absolute;
  left: 50%;
  width: 900px;
  padding: 35px;
  background: transparent;

  border-radius: 7px;
  z-index: 1000;
  top: 50%;
  transition: background 0.3s ease;
  transform: translateX(-50%) translateY(-50%);
}
.contain-form {
  background: linear-gradient(0, black, #00000020);
  backdrop-filter: blur(20px);
}

.form {
  width: 100%;
  margin-bottom: 15px;
  position: relative;
}
.counterbox-title {
  font-size: 45pt;
  font-weight: bold;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 15px;
  z-index: 1000;
  user-select: none;
  text-align: center;
}
.actions {
  text-align: center;
  position: relative;
}
.btns {
  display: flex;
  width: 100%;
  align-items: center;
}
.getonebtn {
  display: flex;
  flex: 1;
  z-index: 1;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: solid 1px #fff;
  color: #fff;
  padding: 15px;
  font-size: 12pt;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0px 0px 0px transparent;
  transition: all 0.1s ease;
  user-select: none;
}
.getonebtn:hover {
  box-shadow: 0px 10px 20px -10px rgba(0, 0, 0, 1), 0px 5px 0px #000000;
}
.getonebtn:active {
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 1), 0px 0px 0px #000000;
  transform: translateY(5px);
  border: solid 1px #01c2fe;
}
.getonebtn:active::before {
  background: #01c2fe;
}
.getonebtn:hover::before {
  transform: translateY(0);
}
.getonebtn::before {
  content: "";
  z-index: -1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  transform: translateY(100%);
  transition: all 0.2s ease;
}
.getonebtn:nth-child(even) {
  margin-left: 10px;
}
@media (max-width: 729px) {
  .counterbox-title {
    font-size: 15pt;
    letter-spacing: 10px;
  }
  .contain {
    width: 90%;
    padding: 35px 15px;
  }
}

.loginForm {
  min-width: 340px;
  text-align: center;
  overflow: hidden;
  background: #222629;
  box-shadow: 80px 59px 76px -30.1px #000000, inset 0px 0px 100.3px #00000090,
    4px 3px 0px 3px #0f1215;
}
.innerForm {
  padding-top: 45px;
}
.loginLogo {
  display: inline-block;
  font-size: 20pt;
  font-weight: 500;
  color: #808080;
  margin-bottom: 50px;
  white-space: nowrap;
  text-align: center;
  width: 100%;
}
.loginLogo img {
  margin-bottom: 15px;
  width: 220px;
}
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background: rgb(82, 82, 82);
  /* background: radial-gradient(circle, rgba(82,82,82,1) 0%, rgba(0,0,0,1) 100%); */
  background-image: url("../../img/texture.png"),
    radial-gradient(circle, rgba(82, 82, 82, 1) 0%, rgba(0, 0, 0, 1) 100%);
  background-size: unset;
  background-position: center;
  background-repeat: repeat;
  box-shadow: inset 0px 0px 300px #000;
}
.loginBtn {
  width: 100%;
  height: 80px !important;
  margin: 0 !important;
  margin-top: 25px !important;
  border-radius: 0px !important;
}
.errorMessage {
  color: #ffffff;
  text-shadow: 1px 1px 10px #ff0000;
  font-weight: 300;
  font-size: 10pt;
  padding: 15px;
  margin-top: 10px;
}
.link {
  cursor: pointer;
  color: #33383b;
  text-decoration: underline;
}
.input-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.dlabel {
  font-size: 15pt;
  color: #fff;
  margin: 5px 0px;
}
</style>